module.exports = __webpack_public_path__ + "img/paper3.43c066a7.png";